/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./draftVideo.defs.js";
export { main as default } from "./draftVideo.defs.js";
